<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.1189 24.072C27.8164 25.4037 26.8505 27 25.3472 27H6.65261C5.14932 27 4.18341 25.4037 4.88095 24.072L14.2283 6.22714C14.9769 4.79782 17.0229 4.79782 17.7716 6.22714L27.1189 24.072ZM25.3472 25L15.9999 7.15515L6.65261 25H25.3472Z"
        />
        <path
            d="M14.9308 21.6126C14.9308 21.0222 15.4095 20.5435 15.9999 20.5435C16.5904 20.5435 17.069 21.0222 17.069 21.6126C17.069 22.2031 16.5904 22.6817 15.9999 22.6817C15.4095 22.6817 14.9308 22.2031 14.9308 21.6126Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.069 13.3919L17.069 19.1398H14.9308L14.9308 13.3919L17.069 13.3919Z"
        />
    </svg>
</template>
